module.exports = "/_next/static/images/unlock-monotone-807c7ced1e1a42304162e49879d6ac4e.svg";